/**
 * The internal-staff realm roles — the principals who work the KYC / underwriting /
 * escalation queues rather than being a customer of the platform.
 *
 * ONE list, consumed by everything that needs to tell "staff" from "customer" (Rule 17):
 *   - `app.config.ts` — the roles whose screens render SLA chips (the portal-side mirror
 *     of `SlaThresholdResource`'s staff-only `@PreAuthorize`; a role added there without
 *     being added here silently loses its SLA colouring, the reverse only puts a 403 in
 *     that role's console);
 *   - the shared notifications inbox — staff receive escalation / SLA traffic, so their
 *     category chips are the Escalations set, not the SME product set (EM-1623).
 *
 * Do NOT re-declare this array in a feature; import it.
 */
export const STAFF_ROLES: readonly string[] = [
  'kyc_officer',
  'underwriter',
  'customer_support',
  'senior_manager',
  'master_admin',
];
